module.exports = __webpack_public_path__ + "static/img/wechat_code4.6dd7d67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wechat_code4.jpg
// module id = JHxP
// module chunks = 13